//* Note: This action file is responsible for controlling actions of rightside toolpane in template page

// eslint-disable-next-line import/prefer-default-export
export const addDynamicField =
  (section, editorState, selectedText, removeHighlightSelection, view) =>
  dispatch => {
    dispatch({
      type: "ADD_DYNAMIC_FIELD",
      payload: {
        section,
        editorState,
        selectedText,
        removeHighlightSelection,
        view,
      },
    });
  };
